import React from 'react'
import { motion } from 'framer-motion';

const Kontakt = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      name='Kontakt' 
      className='w-full h-screen bg-gradient-to-b from-white to-white p-4 text-black'
    >
      <div className='flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full'>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className='pb-8'
        >
          <p className='text-4xl font-bold inline border-b-4 border-black'>Contact</p>
          <motion.p 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className='py-6'
          >
            Fill out the formula below to reach me or send me an email at <a href="mailto:Villingerbl@gmail.com"> Villingerbl@gmail.com</a>. I am looking forward to meeting you.
          </motion.p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 1, duration: 1 }}
          className='flex justify-center items-center'
        >
          <form action="https://getform.io/f/675b4b02-e745-4623-86ce-a66ef7ceeb54" method='POST' className='flex flex-col w-full md:w-1/2'>
            <input 
              type="text" 
              name='name' 
              placeholder='  Your Name'
              className='p2 bg-transparent border-2 rounded-md text-black focus:outline-none'
            />
            <input 
              type="text" 
              name='email' 
              placeholder='  Your Email'
              className='my-4 p2 bg-transparent border-2 rounded-md text-black focus:outline-none'
            />
            <textarea 
              name="message" 
              placeholder='Your Message'
              rows="10"
              className='p-2 bg-transparent border-2 rounded-md text-black focus:outline-none'
            ></textarea>
            <button className='text-white px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300' style={{ background: 'rgb(1, 50, 32)' }}>Send</button>
          </form>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 1.4, duration: 1 }}
          className='flex justify-center items-center mt-8'
        >
          <div className='w-full md:w-1/2 text-center'>
            <h3 className='text-xl font-bold mb-4'>Villinger  ApS</h3>
            <p className='mb-2'>Lucas Bernardo Villinger</p>
            <p className='mb-2'>Email: Villingerbl@gmail.com</p>
            <p className='mb-2'>Telefon: +45 29 36 46 14</p>
            <p className='mb-2'>CVR: 45 32 04 99</p>
            
          </div>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default Kontakt